<template>
    <td-dialog
        :lockScroll="false"
        :title="title"
        :before-close="labelGroupDialogClose"
        :visible.sync="dialogLabelGroupVisible"
        width="400px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
    >
        <el-form :model="labelGroupInfo" label-position="right" label-width="95px" ref="labelGroupInfo" :rules="rules">
            <el-form-item :label="$t('workFlowLabelGroup.LABEL_GROUP_NAME')" prop="sName">
                <td-input v-model="labelGroupInfo.sName" :minlength="1" :maxlength="20"></td-input>
            </el-form-item>
            <el-form-item :label="$t('workFlowLabelGroup.LABEL_GROUP_REMARK')" prop="sRemark">
                <td-input v-model="labelGroupInfo.sRemark" :minlength="1" :maxlength="6"> </td-input>
            </el-form-item>
        </el-form>
        <span slot="footer">
            <td-button type="primary" @click="submitForm('labelGroupInfo')" :loading="submitLoading">{{ $t('pgCommon.SAVE') }}</td-button>
            <td-button @click="labelGroupDialogClose">{{ $t('pgCommon.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import groupApi from './../assets/api.js';
export default {
    props: ['title', 'dialogLabelGroupVisible', 'editItem', 'isAdd'],
    created() {
        // 为编辑状态则进行初始化数据
        if (!this.isAdd) {
            this.labelGroupInfo = this.editItem;
        }
    },
    // 定义变量
    data() {
        return {
            // 表单信息
            labelGroupInfo: {
                sId: '',
                sName: '',
                sRemark: '',
                iInitType: 0
            },
            submitLoading: false, // 保存按钮是否为加载状态
            // 对表单进行数据验证
            rules: {
                sName: [
                    { required: true, message: this.$t('workFlowLabelGroupError.ERROR_PLEASE_INPUT_GROUP_NAME'), trigger: 'blur' },
                    { pattern: window.pangu.regex.ENGLISH_AND_UNDERLINE, message: this.$t('workFlowLabelGroupError.ONLY_ENGLISH_UNDERLINE'), trigger: 'blur' }
                ],
                sRemark: [
                    { required: true, message: this.$t('workFlowLabelGroupError.ERROR_PLEASE_INPUT_GROUP_REMARK'), trigger: 'blur' },
                    { pattern: window.pangu.regex.CAPTION_RULE, message: this.$t('workFlowLabelGroupError.CAPTION_RULE_ERROR_MSG'), trigger: 'blur' }
                ]
            }
        };
    },
    // 定义并实现方法体
    methods: {
        // 提交数据
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.submitLoading = true;
                    var param = {
                        sId: this.labelGroupInfo.sId,
                        sName: this.labelGroupInfo.sName,
                        sRemark: this.labelGroupInfo.sRemark,
                        iInitType: this.labelGroupInfo.iInitType
                    };
                    if (this.isAdd) {
                        param.sId = this.getuuid();
                        groupApi.addLabelGroup(JSON.stringify(param), response => {
                            this.submitLoading = false;
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/workFlowLabelGroup/addLabelGroup', response.data.statusMessage);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('workFlowLabelGroup.ADD_SUCCESS'), type: 'success' });
                            this.labelGroupDialogClose();
                            //回调父页面刷新单列表数据
                            this.$emit('addTableNode', param);
                        });
                    } else {
                        groupApi.updateLabelGroup(JSON.stringify(param), response => {
                            this.submitLoading = false;
                            if (response.data.statusCode !== window.vue.$common.requestCode.SUCCESS_INFO_CODE) {
                                this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                                this.$log.error('/workFlowLabelGroup/updateLabelGroup', response.data.statusMessage);
                                return;
                            }
                            this.$message({ showClose: true, message: this.$t('workFlowLabelGroup.MODIFY_SUCCESS'), type: 'success' });
                            this.labelGroupDialogClose();
                            //回调父页面刷新单列表数据
                            this.$emit('updateTableNode', param);
                        });
                    }
                }
            });
        },
        // 关闭窗口之前需要调用的方法
        labelGroupDialogClose() {
            this.$emit('labelGroupDialogClose');
            this.$refs['labelGroupInfo'].resetFields(); // 重置表单数据
        },
        //生成uuid
        getuuid() {
            return 'xxxx-xxxx-xxxx-xxxx-xxxx'.replace(/[xy]/g, function(c) {
                let r = (Math.random() * 16) | 0,
                    v = c == 'x' ? r : (r & 0x3) | 0x8;
                return v.toString(16);
            });
        }
    }
};
</script>
<style></style>
